import moment from 'moment'
moment.locale('es')

export default function (value, format) {
  return moment(value).format(format || 'LLL')
}



// WEBPACK FOOTER //
// ./src/filters/date.filter.js